import { formatTimestamp } from '../../utils/formatTimestamp';

export function formatWhen(timestamp: string, now: Date = new Date()) {
  const d = new Date(timestamp);
  if (Number.isNaN(d.getTime())) return { absolute: timestamp, relative: '' };
  const absolute = formatTimestamp(timestamp);
  const mins = Math.round((now.getTime() - d.getTime()) / 60000);
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const relative =
    Math.abs(mins) < 60
      ? rtf.format(-mins, 'minute')
      : Math.abs(mins) < 1440
        ? rtf.format(-Math.round(mins / 60), 'hour')
        : rtf.format(-Math.round(mins / 1440), 'day');
  return { absolute, relative };
}

export function clampText(text: string, max: number): string {
  return text.length <= max ? text : `${text.slice(0, max).trimEnd()}…`;
}

/** Label for one row in the prompt's Attached list. */
export function attachedRow(kind: string | null | undefined, name: string | null | undefined): { name: string; pill: string } {
  const normalized = (kind || '').trim().toLowerCase();
  if (normalized === 'agent') return { name: 'Supporting Agent', pill: 'Agent' };
  if (normalized === 'rule') return { name: 'Supporting Rule', pill: 'Rule' };
  if (normalized === 'skill') return { name: name?.trim() || 'Untitled', pill: 'Skill' };
  return { name: name?.trim() || 'Untitled', pill: 'File' };
}
